import React from 'react';
import Icon from 'shared/components/Icon';

import CheckIcon from 'assets/images/icon-item-checkmark.svg';

import './styles.scss';

const LandingPageDetails = ({
  headers = {},
  event = {},
  additionalDetails = {},
  titleSubtitle = {},
}) => (
  <>
    <div className="landing-page-event-details">
      {Object.keys(titleSubtitle).map((key) => (
        <div key={key}>
          <p className="title">{key}</p>
          <p className="subtitle">{titleSubtitle[key]}</p>
        </div>
      ))}
      <p className="header">{headers.header}</p>
      <p className="description">{event.description}</p>
      {Boolean((event.callOuts || []).length) && (
        <>
          <p className="header">{headers.subHeader}</p>
          {event.callOuts.map(
            (callOut, index) =>
              callOut && (
                <div key={index} className="callout-items">
                  <Icon icon={CheckIcon} />
                  <span className="callout">{callOut}</span>
                </div>
              )
          )}
        </>
      )}
      {Object.keys(additionalDetails).map((key) => {
        return (
          additionalDetails[key] && (
            <div key={key}>
              <p className="header">{key}</p>
              <p className="description">{additionalDetails[key]}</p>
            </div>
          )
        );
      })}
    </div>
  </>
);

export default LandingPageDetails;
